import React, { useMemo } from "react";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import DialogDeleteShell from "./DialogDeleteShell";

function displayFileName(record, fallbackKey) {
  const file = _.get(record, "file", "");
  const ext = file.includes(".") ? file.substring(file.lastIndexOf(".")) : "";
  const baseName = _.get(record, fallbackKey) || _.get(record, "uploadedFileName") || file;
  return baseName && !String(baseName).includes(".") && ext ? baseName + ext : baseName;
}

export default function dialogAtlasDelete(props) {
  const atlasRecords = useMemo(
    () => (props.atlases || []).filter((a) => a.animationSet === props.animationSetToDeleteID),
    [props.animationSetToDeleteID, props.atlases]
  );
  const atlasToSearch = atlasRecords[0] || null;
  const assetNames = useMemo(
    () => atlasRecords.map((r) => displayFileName(r, "uploadedFileName")).filter(Boolean),
    [atlasRecords]
  );

  const handleDelete = (progressID) => {
    return fetch(getServerUri("atlas/deleteAnimationSet"), {
      method: "DELETE",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        animationSetID: _.get(props, "animationSetToDeleteID", ""),
        progressID: progressID || "",
      }),
    }).then((response) => {
      if (response.status === 200) {
        const newAtlases = props.atlases.filter(
          (atlas) => atlas.animationSet !== props.animationSetToDeleteID
        );
        props.deleteAnimationSetFromAtlases(props.animationSetToDeleteID);
        props.setAtlases(newAtlases);
        props.createSnackbar("Atlas deleted", "success");
        props.onAfterDelete?.();
        return true;
      } else {
        response.text().then(console.log).catch(console.error);
        return false;
      }
    });
  };

  return (
    <DialogDeleteShell
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      assetNames={assetNames}
      assetID={_.get(atlasToSearch, "_id")}
      assetFile={_.get(atlasToSearch, "file")}
      assetType="atlas"
      onConfirmDelete={handleDelete}
      createSnackbar={props.createSnackbar}
      errorMessage="An error occurred deleting the atlas."
    />
  );
}
